export default __webpack_public_path__ + "static/media/kitchen5-beforeE-1440w.fff784a3.webp";